import { render, staticRenderFns } from "./BuffetSetupBottomBar.vue?vue&type=template&id=00b49157&scoped=true&"
import script from "./BuffetSetupBottomBar.vue?vue&type=script&lang=js&"
export * from "./BuffetSetupBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./BuffetSetupBottomBar.vue?vue&type=style&index=0&id=00b49157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b49157",
  null
  
)

export default component.exports